export enum ExternalScripts {
  SEGMENT = "segment",
  CHILIPIPER = "chilipiper",
  MARKETO = "marketo",
  AIRGAP = "airgap",
  QUALIFIED = "qualified",
  GOOGLE_TAG_MANAGER = "google-tag-manager",
  GLANCE_COBROWSE = "glance-cobrowse",
}
